import React, { useState, useRef, forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { CalendarContainer as CustomisableContainer } from 'react-datepicker';
import DatePickerBase from '../DatePickerBase';
import Button from '../Button';
import Typography from '../Typography';
import Box from '../Box';
import { makeStyles } from '../styles';
import { CalendarIcon } from '../icons';
const ModalContainer = ({ children }) => createPortal(children, document.body);
const useStyles = makeStyles(({ spacing, zIndex, palette }) => ({
    button: {
        margin: spacing(),
        minWidth: `calc(50% - 18px)`,
    },
    popper: {
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        zIndex: zIndex.leafeltMax * 2,
        backgroundColor: '#00000050',
        transform: 'translate3d(0px, 0px, 0px)!important',
    },
    inputRoot: {
        cursor: 'pointer',
        minWidth: 100,
    },
    calanderIcon: {
        marginLeft: spacing(),
        color: palette.secondary.main,
    },
    placeholder: {
        color: palette.text.secondary,
    },
}));
const CustomInput = forwardRef(({ value, onClick, inputClassName, placeholder, typographyVariant = 'body2', }, ref) => {
    const classes = useStyles();
    return (React.createElement(Box, { ref: ref, className: classNames(inputClassName, classes.inputRoot), onClick: onClick, alignItems: "center", width: "100%", justifyContent: "space-between" },
        React.createElement(Typography, { className: classNames({ [classes.placeholder]: !value }), variant: typographyVariant }, value || placeholder),
        React.createElement(CalendarIcon, { size: "medium", className: classes.calanderIcon })));
});
function ModalDatePicker({ inputClassName, onChange, startDate, placeholder, typographyVariant, }) {
    const classes = useStyles();
    const ref = useRef(null);
    const [selectedDate, setSelectedDate] = useState(() => startDate ? new Date(startDate) : undefined);
    const handleCloseModal = () => {
        ref.current.setOpen(false);
    };
    const handleCancel = () => {
        setSelectedDate(startDate ? new Date(startDate) : undefined);
        handleCloseModal();
    };
    const handleChange = () => {
        onChange(selectedDate);
        handleCloseModal();
    };
    const CalendarContainer = ({ className, children }) => {
        return (
        // @ts-ignore
        React.createElement(CustomisableContainer, { className: className },
            React.createElement("div", { style: { position: 'relative' } }, children),
            React.createElement(Button, { onClick: handleCancel, className: classes.button, theme: "secondary" },
                React.createElement(FormattedMessage, { id: "navigation.canel", defaultMessage: "Cancel" })),
            React.createElement(Button, { onClick: handleChange, className: classes.button },
                React.createElement(FormattedMessage, { id: "navigation.save", defaultMessage: "Save" }))));
    };
    return (React.createElement(DatePickerBase, { ref: ref, 
        // @ts-ignore
        calendarContainer: CalendarContainer, customInput: React.createElement(CustomInput, { inputClassName: inputClassName, typographyVariant: typographyVariant }), dateFormat: "yyyy-MM-dd", fixedHeight: true, onChange: date => setSelectedDate(date), openToDate: startDate ? new Date(startDate.toISOString()) : new Date(), placeholderText: placeholder, popperContainer: ModalContainer, popperClassName: classes.popper, selected: selectedDate, shouldCloseOnSelect: false }));
}
export default ModalDatePicker;
//# sourceMappingURL=ModalDatePicker.js.map